import {config} from "@/constants/config";
import type {TResponseRequest} from "@/interfaces/http.interface";
import httpRequest from "@/providers/http/request.http";

export interface Provider {
  id: string;
  code: string;
  name: string;
  logo: string;
  website: string;
  description: string;
  is_active: boolean;
  created_at?: string;
  updated_at?: string;
}

export interface CreateProviderDto {
  code: string;
  name: string;
  logo?: string;
  website?: string;
  description?: string;
  is_active?: boolean;
}

export interface UpdateProviderDto {
  name?: string;
  logo?: string;
  website?: string;
  description?: string;
  is_active?: boolean;
}

export const getProvidersService = async (): Promise<TResponseRequest<Provider[]>> => {
  return httpRequest.get<Provider[]>({
    url: `${config.walletApiUrl}/bo/providers`,
  });
};

export const getProviderByIdService = async (id: string): Promise<TResponseRequest<Provider>> => {
  return httpRequest.get<Provider>({
    url: `${config.walletApiUrl}/bo/providers/${encodeURIComponent(id)}`,
  });
};

export const createProviderService = async (body: CreateProviderDto): Promise<TResponseRequest<Provider>> => {
  return httpRequest.post<Provider>({
    url: `${config.walletApiUrl}/bo/providers`,
    body: body as unknown as Record<string, unknown>,
  });
};

export const updateProviderService = async (
  id: string,
  body: UpdateProviderDto
): Promise<TResponseRequest<Provider>> => {
  return httpRequest.put<Provider>({
    url: `${config.walletApiUrl}/bo/providers/${encodeURIComponent(id)}`,
    body: body as unknown as Record<string, unknown>,
  });
};

export const toggleProviderActiveService = async (
  id: string,
  isActive: boolean
): Promise<TResponseRequest<boolean>> => {
  return httpRequest.patch<boolean>({
    url: `${config.walletApiUrl}/bo/providers/${encodeURIComponent(id)}/active`,
    body: {is_active: isActive},
  });
};

export const deleteProviderService = async (id: string): Promise<TResponseRequest<void>> => {
  return httpRequest.delete<void>({
    url: `${config.walletApiUrl}/bo/providers/${encodeURIComponent(id)}`,
    body: {},
  });
};
